import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { AssetSectionDefinationsList } from './assetSectionDefinition.types';

export const assetSectionDefinationsListPullQueryBuilder = (
  document: AssetSectionDefinationsList,
) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query allAssetSectionDefinationsMobile($lastRequested: DateTime!) {
      allAssetSectionDefinationsMobile(lastRequested: $lastRequested) {
        name
        id
        active
        dateCreated
        dateModified
        dynamicProperties {
          name
          id
          isFieldEditable
          lOV {
            value
            display
            sort
          }
        }
      }
    }
  `);
  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};
